// React Imports
import {useSelector} from "react-redux";
import * as React from "react";

// Mui Imports
import {Stack} from "@mui/material";

// App Imports
import EpisodeContractStatsGrid from "../WorkStats/EpisodeContractStats";
import QueueMethodTabs from "../Header/QueueMethodTabs";
import WorkQueuePropertyDropdownList from "../Header/WorkQueuePropertyDropdownList";
import ContractSearch from "../Contracts/ContractSearch";
import ContractHierarchySearchBar from "../Header/ContractHierarchySearchBar";


// main function
export default function WorkQueueHeader(props) {

    const selectorCardState = useSelector((state) => state.workQueueSlc.value.cardsState);
    const selectorMethodTabsState = useSelector((state) => state.workQueueSlc.value.methodTabsState);
    const selectorPropertySearchState = useSelector((state) => state.workQueueSlc.value.propertySearchState);


    return(
        <div>
            {selectorCardState === true && <ContractHierarchySearchBar/>}
            {selectorCardState === false &&
                <Stack direction={"row"} spacing={2}>

                {(selectorMethodTabsState === true) &&
                                           <QueueMethodTabs/>}
                {(selectorPropertySearchState === true) &&
                    <WorkQueuePropertyDropdownList/>}
                {/*{(useSelector((state) => state.workQueueSlc.value.unstructuredSearchState) === true) &&*/}
                {/*    <ContractSearch/>}*/}
            </Stack>}
        </div>
    )
}